import React, { Component } from 'react'
import { graphql } from 'react-apollo'
import Datetime from 'react-datetime'
import PropTypes from 'prop-types'
import cn from 'classnames'
import get from 'lodash/get'
import moment from 'moment'
import 'react-datetime/css/react-datetime.css'

import CHANGE_SUBMISSION_MUTATION from '../../graphql/mutations/ChangeSubmissionMutation.graphql'
import { submissionsClosed } from '../../utils'

const MODAL_ID = 'closeSubmissionsModal'
const MODAL_LABEL_ID = 'closeSubmissionsLabel'

class ChangeSubmission extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showModal: false,
      date: props.board.submissionEndDate,
      remindOption: props.board.remindOption,
    }
  }

  handleChangeSubmission = async () => {
    await this.props.mutate({
      variables: {
        uuid: this.props.board.uuid,
        submissionEndDate: this.state.date,
        remindOption: this.state.remindOption
      },
    })
  }

  handleCloseSubmissionNow = () => {
    this.setState(
      {
        date: moment(),
      },
      this.handleChangeSubmission
    )
  }

  handleOpenModal = () => {
    this.setState({
      showModal: true,
      date: this.props.board.submissionEndDate,
    })
  }

  handleCloseModal = () => {
    this.setState({
      showModal: false,
    })
  }

  handleBackdropClick = e => {
    if (get(e, 'target.id') === MODAL_ID) {
      this.handleCloseModal()
    }
  }

  handleremindOptionChange(event) {
    console.log('handleremindOptionChange:'+event.target.value);
    this.setState({remindOption: event.target.value})
  }

  componentDidUpdate() {
    document.body.classList.toggle('modal-open', this.state.showModal)
  }

  render() {
    const { date, showModal } = this.state
    const { board } = this.props

    if (board.isArchived) {
      return null
    }

    return (
      <div className="col-sm-6 col-md-3 col-lg-2 pb-2">
          <div>
            <button className="btn btn-primary btn-block" onClick={this.handleOpenModal}>
                <i className="fa fa-edit" /><span className="ml-2">Edit End Date</span>
            </button>
          </div>


        <div
          className={cn('modal fade', { show: showModal })}
          id={MODAL_ID}
          tabIndex="-1"
          role="dialog"
          aria-labelledby={MODAL_LABEL_ID}
          aria-hidden="true"
          style={{ display: showModal ? 'block' : 'none' }}
          onClick={this.handleBackdropClick}
        >
          <div className="modal-dialog" role="document" style={{ width: 300 }}>
            <div className="modal-content">
              <div className="modal-header">
                <div className="container">
                  <div className="row justify-content-center">
                    <h5 className="modal-title align-content-center text-center" id={MODAL_LABEL_ID} >
                      <strong>Session Closing Time</strong>
                    </h5>
                    </div>
                </div>
                <button onClick={this.handleCloseModal} className="close" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body text-center">
                <Datetime
                  value={Date.parse(date)}
                  input={false}
                  isValidDate={current => current.isAfter(moment().subtract(1, 'day'))}
                  onChange={date => this.setState({ date })}
                />
                <div className="py-2"></div>

                <div className="form-group">
                  {/*<label htmlFor="closeOption"><strong>Remind Channel Before Closing Time</strong></label>*/}
                  <label htmlFor="remindOption"><strong>Remind Channel Before Closing</strong></label>
                  <select className="form-control" id="remindOption" value={this.state.remindOption}
                          onChange={this.handleremindOptionChange.bind(this)}>
                    <option value="0">No Reminder</option>
                    <option value="60">1 hour before</option>
                  </select>
                </div>


              </div>
              <div className="modal-footer">

                  <button className="btn btn-secondary" onClick={this.handleCloseModal}>
                      Cancel
                  </button>

                  {!submissionsClosed(board) && (
                      <button className="btn btn-primary"
                              onClick={() => {
                                  this.handleCloseSubmissionNow()
                                  this.handleCloseModal()
                              }}
                      >
                          {/*<i className="fa fa-times-circle" />&nbsp; Close Now*/}
                          End Now
                      </button>
                  )}

                <button
                  className="btn btn-primary"
                  onClick={() => {
                    this.handleChangeSubmission()
                    this.handleCloseModal()
                  }}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
        {showModal && <div className="modal-backdrop fade show" />}
    </div>
    )
  }
}

ChangeSubmission.propTypes = {
  board: PropTypes.shape({
    uuid: PropTypes.string.isRequired,
    submissionEndDate: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
}

export default graphql(CHANGE_SUBMISSION_MUTATION)(ChangeSubmission)



// WEBPACK FOOTER //
// ./src/components/Board/ChangeSubmission.jsx